/**
 * Scroll Animation Utilities
 * 
 * Centralized scroll animation logic for wobble effects on event images.
 * Used across multiple pages to create consistent animation behavior.
 */

import { useEffect } from 'react';

/**
 * Custom hook for scroll-triggered wobble animation
 * Adds wobble effect to event images when they come into viewport center
 */
export const useScrollWobble = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Scroll event handler for wobble animation
    const handleScroll = () => {
      const events = document.querySelectorAll('.event');
      const timelineEvents = document.querySelectorAll('.timeline-event');
      const viewportHeight = window.innerHeight;
      const viewportCenter = viewportHeight / 2;
      
      // Handle regular events
      events.forEach((event) => {
        const eventImage = event.querySelector('.event-image');
        if (eventImage && !eventImage.classList.contains('wobble')) {
          const imageRect = eventImage.getBoundingClientRect();
          const imageCenter = imageRect.top + imageRect.height / 2;
          
          // Check if image center is close to viewport center
          if (Math.abs(imageCenter - viewportCenter) < 150) {
            eventImage.classList.add('wobble');
            // Remove the wobble class after animation completes
            setTimeout(() => {
              eventImage.classList.remove('wobble');
            }, 1500);
          }
        }
      });
      
      // Handle timeline events
      timelineEvents.forEach((event) => {
        const eventImage = event.querySelector('.event-image');
        if (eventImage && !eventImage.classList.contains('wobble')) {
          const imageRect = eventImage.getBoundingClientRect();
          const imageCenter = imageRect.top + imageRect.height / 2;
          
          // Check if image center is close to viewport center
          if (Math.abs(imageCenter - viewportCenter) < 150) {
            eventImage.classList.add('wobble');
            // Remove the wobble class after animation completes
            setTimeout(() => {
              eventImage.classList.remove('wobble');
            }, 1500);
          }
        }
      });
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Check on initial load after a short delay
    setTimeout(() => {
      handleScroll();
    }, 100);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};

/**
 * Utility function to scroll to top of page
 */
export const scrollToTop = () => {
  window.scrollTo(0, 0);
};